module.exports = __webpack_public_path__ + "img/cement-matrix@2x.35cb8a67.png";